export const CATALOGS_PUBLICACIONES = [
  { value: 1, label: 'Divulgación' },
  { value: 2, label: 'Téoricas' },
  { value: 3, label: 'Digitales' },
];

export const COLUMNS_PUBLICACIONES = (value) => {
  const data = [
    { id: 'Tipo', label: 'Tipo', type: 'text' },
    { id: 'FechaPublicacion', label: 'Publicación', type: 'text' },
    { id: 'Vistas', label: 'Vistas', type: 'text' },
    { id: 'Nombre', label: 'Nombre', type: 'text' },
    { id: 'Descripcion', label: 'Descripción', type: 'text' },
    { id: 'Sinopsis', label: 'Sinopsis', type: 'text' },
    { id: 'fileURLImg', label: 'Portada', type: 'text' },
    { id: 'fileName', label: 'Archivo', type: 'text' },
  ];

  if (value)
    data.push({ id: 'actions', label: 'Acciones', sort: false, align: 'center', disablePadding: true });

  return data;
};

export const camposAEliminar = [
  'Acciones',
  'idMunicipio',
  'imagePath',
  'imageName',
  'image',
  'Nombre',
  'Municipio',
  'Email',
  'TableOrder',
  'Cargo',
  'FileURL',
];

export const columns = (permission, type) => {
  const hasPermission = Object.values(permission).some(Boolean);

  const baseColumns = [
    ...(type !== 0 ? [{ id: 'Municipio', label: 'Municipio' }] : []),
    { id: 'Nombre', label: 'Nombre' },
    { id: 'Cargo', label: 'Cargo' },
    { id: 'Email', label: 'Correo' },
    { id: 'image', label: 'Imagen' },
  ];

  if (hasPermission) {
    baseColumns.push({ id: 'Acciones', label: 'Acciones' });
  }

  return baseColumns;
};
